import React from "react";
import {
	getSystemVersion,
	formatSystemReleaseDateBr,
	getSystemReleaseDate,
} from "../../helpers/systemInfo";

function AuthCopyright() {
	const releaseLabel = formatSystemReleaseDateBr(getSystemReleaseDate());

	return (
		<p className="mt-8 text-center text-sm text-default-500">
			© {new Date().getFullYear()}
			{" - "}
			<a
				className="text-default-600 hover:text-primary"
				href={`https://${process.env.REACT_APP_NOME}.com.br`}
			>
				{process.env.REACT_APP_NOME} - v{getSystemVersion()}
				{releaseLabel ? ` (${releaseLabel})` : ""}
			</a>
			.
		</p>
	);
}

export default AuthCopyright;
